<template>
  <v-card>
    <v-card-title>
      <SelectDates
        @updateDates="onDatesUpdate"
        :days="days"
      />
      <v-spacer></v-spacer>
      <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
    </v-card-title>
    <v-layout column>
      <v-flex style="overflow: auto">
        <v-data-table
          v-if="loaded > 5 || loaded == devices.length"
          :headers="headers"
          :items="devices"
          :search="search"
          :key="loaded"
          :loading="loading"
          item-key="id"
          :custom-sort="customSort"
          must-sort
          :pagination.sync="pagination_sync"
        >
          <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
          <template slot="items" slot-scope="props">
            <tr @click="clickTableRow(props.item)">
              <td v-for="header in headers" :key="header.id">
                <span :class="header.class">{{ props.item[header.value] }}</span>
              </td>
            </tr>
          </template>
          <v-alert slot="no-results" :value="true" color="error" icon="warning">
            Your search for
            <strong>"{{ search }}"</strong> found no results.
          </v-alert>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
import moment from 'moment'
import SelectDates from '@/components/Common/SelectDates'
export default {
  name: 'StatusListTable',
  components: { SelectDates },
  props: {
    parentID: {
      type: Number,
      default: null
    },
    days: {
      type: Number,
      default: 1
    },
    headers: {
      type: Array // Data Table , columns, values
    },
    pagination: {
      type: Object // Data Table, sort, pagination control
    },
    metrics: {
      type: Object // Computed, metrics: 'counters' - device codec field names
    }
  },
  data () {
    return {
      pagination_sync: {},
      search: '',
      devices: [], // List of devices - augmented with their data (messages, metrics)
      loaded: 0, // Number of device->messages loaded (gets incremented for each async fetch)
      loading: true,
      // Set up the date picker query variables (updated in child SelectDates)
      datefromQuery: moment()
        .subtract(this.days, 'days')
        .format('YYYYMMDD000000'),
      datetoQuery: moment().format('YYYYMMDD235959')
    }
  },
  beforeMount () {
    this.pagination_sync = this.pagination
    this.fetchDevices()
  },
  methods: {
    onDatesUpdate (dateto, datefrom) {
      this.datetoQuery = moment(dateto).format('YYYYMMDD235959')
      this.datefromQuery = moment(datefrom).format('YYYYMMDD000000')
    },
    customSort (items, index, isDesc) {
      items.sort((a, b) => {
        var modifier = (isDesc ? -1 : 1)
        if (a[index] === undefined) return -1 * modifier
        if (b[index] === undefined) return 1 * modifier
        if (a[index] < b[index]) return -1 * modifier
        if (a[index] > b[index]) return 1 * modifier
        return 0
      })
      return items
    },
    failedDeviceMessagesList (error) {
      this.$emit('error', error)
      // eslint-disable-next-line
      console.log(`Error(${error} - fetching/building DeviceMessages List)`)
    },
    failedDeviceList () {
      this.$emit('error', 'Failed to retrieve a list of devices.')
    },
    buildDeviceList (data) {
      // Assign and initialise placeholder objects
      var messages = { messages: [] }
      var devices = []
      var displayname = { displayname: '' }
      var computed = { computed: '' }
      var alerts = { alerts: {} }
      var count1 = { count1: null }
      var count2 = { count2: null }
      // eslint-disable-next-line camelcase
      var delta_avg1 = { delta_avg1: null }
      // eslint-disable-next-line camelcase
      var delta_avg2 = { delta_avg2: null }
      var maximum1 = { maximum1: null }
      var maximum2 = { maximum2: null }
      var minimum1 = { minimum1: null }
      var minimum2 = { minimum2: null }
      // Create the devices[] data structures
      for (var i = 0; i < data.devices.length; i++) {
        devices[i] = Object.assign({}, data.devices[i], displayname, messages, alerts, count1, count2, delta_avg1, delta_avg2, maximum1, maximum2, minimum1, minimum2, computed)
      }
      this.devices = devices
      // Kick off the secondary overlapping queries to populate each device->messages,metrics
      for (i = 0; i < data.devices.length; i++) {
        this.fetchDeviceMessagesMetrics(i, devices[i])
      }
    },
    async fetchDevices () {
      var urlParams = {}
      if (this.parentID && this.parentID >= 0) {
        urlParams.parentid = this.parentID
        // Get the list of devices
        await this.$http
          .get('/schemas/devices', { params: urlParams })
          .then(request => this.buildDeviceList(request.data))
          .catch(() => this.failedDeviceList())
      }
    },
    computeCompliance (data) {
      var computed = ['NO', 'NO', 'NO', 'NO', 'NO']
      // Passed from 'OrgSettings' - variable names defined in device metrics 'counter' fields
      if (this.metrics.computed1 !== undefined &&
          this.metrics.computed1 === 'LegionellaCompliance') {
        // Relies on WavetrendWateTemp configuration - assumed sensor2 is HOT, sensor1 is COLD
        if (data.metrics.counters[this.metrics.count2] > 0 &&
            (data.metrics.counters[this.metrics.count1] > 0 || data.metrics.mins[this.metrics.minimum1] < 20)) {
          computed[0] = 'YES'
        }
      }
      if (this.metrics.computed2 !== undefined &&
          this.metrics.computed2 === 'HotOnlyCompliance') {
        // Relies on WavetrendWateTemp configuration - assumed sensor2 is HOT
        if (data.metrics.counters[this.metrics.count2] > 0) {
          computed[1] = 'YES'
        }
      }
      if (this.metrics.computed3 !== undefined &&
          this.metrics.computed3 === 'HotHotCompliance') {
        // Relies on WavetrendWateTemp configuration - assumed sensor2 and 1 are HOT, HOT
        if (data.metrics.counters[this.metrics.count1] > 0 &&
            data.metrics.counters[this.metrics.count2] > 0) {
          computed[2] = 'YES'
        }
      }
      if (this.metrics.computed4 !== undefined &&
          this.metrics.computed4 === 'ColdOnlyCompliance') {
        // Relies on WavetrendWateTemp configuration - assumed sensor1 is COLD
        if (data.metrics.counters[this.metrics.count1] > 0 || data.metrics.mins[this.metrics.minimum1] < 20) {
          computed[3] = 'YES'
        }
      }
      if (this.metrics.computed5 !== undefined &&
          this.metrics.computed5 === 'ColdColdCompliance') {
        // Relies on WavetrendWateTemp configuration - assumed sensor1, 2 are COLD, COLD
        if ((data.metrics.counters[this.metrics.count1] > 0 || data.metrics.mins[this.metrics.minimum1] < 20) &&
             (data.metrics.counters[this.metrics.count2] > 0 || data.metrics.mins[this.metrics.minimum2] < 20)) {
          computed[4] = 'YES'
        }
      }
      return computed
    },
    buildAugmentdDeviceList (deviceIndex, data) {
      // DEBUG - uncomment following lines
      // var name = ''
      // if (data.messages !== undefined) {
      //   if (data.messages.length > 0) name = data.messages[0].author_devicename
      // }
      // // eslint-disable-next-line
      // console.log(`Building AugmentedList[${deviceIndex}] - ${name}`)
      // END-DEBUG

      // Augment devices[] object - with it's data(mesagaes, metrics)
      var device = this.devices[deviceIndex]

      // DEBUG - uncomment following lines
      // // eslint-disable-next-line
      // console.log(`Building AugmentedList[${deviceIndex}] - ${device.id}, ${device.devicename}`)
      // END-DEBUG

      device.messages = data.messages
      device.displayname = device.identity_data.displayname
      if (data.metrics !== undefined && this.metrics.enabled) {
        // Do compliance computation as per orgSetting's .. for this data metrics set
        var computed = this.computeCompliance(data)
        device.computed1 = computed[0]
        device.computed2 = computed[1]
        device.computed3 = computed[2]
        device.computed4 = computed[3]
        device.computed5 = computed[4]
        if (data.metrics.counters[this.metrics.count1] !== undefined) device.count1 = data.metrics.counters[this.metrics.count1]
        if (data.metrics.counters[this.metrics.count2] !== undefined) device.count2 = data.metrics.counters[this.metrics.count2]
        device.alerts = data.metrics.alerts !== undefined ? data.metrics.alerts : ''
      }
      if (data.metrics !== undefined && this.metrics.deltas) {
        if (data.metrics.deltas[this.metrics.delta_avg1] !== undefined) device.delta_avg1 = data.metrics.deltas[this.metrics.delta_avg1]
        if (data.metrics.deltas[this.metrics.delta_avg2] !== undefined) device.delta_avg2 = data.metrics.deltas[this.metrics.delta_avg2]
        if (data.metrics.maxes[this.metrics.maximum1] !== undefined) device.maximum1 = data.metrics.maxes[this.metrics.maximum1]
        if (data.metrics.maxes[this.metrics.maximum2] !== undefined) device.maximum2 = data.metrics.maxes[this.metrics.maximum2]
        if (data.metrics.mins[this.metrics.minimum1] !== undefined) device.minimum1 = data.metrics.mins[this.metrics.minimum1]
        if (data.metrics.mins[this.metrics.minimum2] !== undefined) device.minimum2 = data.metrics.mins[this.metrics.minimum2]
        device.alerts = data.metrics.alerts !== undefined ? data.metrics.alerts : ''
      }
      this.devices[deviceIndex] = device

      this.loaded += 1
      if (this.loaded === this.devices.length) {
        this.loading = false
      }
    },
    async fetchDeviceMessagesMetrics (deviceIndex, deviceData) {
      // DEBUG - uncomment following lines
      // // eslint-disable-next-line
      // console.log(`Fetching/building DeviceMessages[${deviceIndex}] - ${deviceData.id}`)
      // END-DEBUG

      var url = `/schemas/deviceid_messages/${deviceData.id}`
      // TODO - allow Daterange to be selected
      if (this.datefromQuery.length > 0) {
        url = url + `?datefrom=${this.datefromQuery}`
        if (this.datetoQuery.length > 0) {
          url = url + `&dateto=${this.datetoQuery}`
        }
      }
      // Make the API request to get the messages for this device.
      // prettier-ignore
      await this.$http
        .get(url)
        .then(response => this.buildAugmentdDeviceList(deviceIndex, response.data))
        .catch(error => this.failedDeviceMessagesList(error))
    },
    clickTableRow (item) {
      /*
      TODO: - allow Daterange to be selected
      */
      this.$router.push({
        name: 'DeviceTypeGraph',
        params: {
          deviceID: item.devicename,
          displayname: item.identity_data.displayname,
          devicetype: item.typename
        },
        query: { datefrom: this.datefromQuery, dateto: this.datetoQuery }
      })
    }
  }
}
</script>
